<template>
  <div class="audio-player">
    <div class="inline-block">
      <audio
        ref="audioPlayer"
        :src="src"
        @playing="isPlaying = true"
        @pause="isPlaying = false"
        @ended="$emit('input', false)"
      />
      <mj-icon
        v-if="!isPlaying"
        src="play"
        class="w-5 h-5 text-gray-900 cursor-pointer"
        @click="play"
      />
      <mj-icon
        v-else
        src="pause"
        class="w-5 h-5 text-pink-500 cursor-pointer"
        @click="pause"
      />
    </div>
    <mj-audio-player-music-wave
      v-show="isPlaying"
      class="inline ml-4"
    />
  </div>
</template>

<script>
import AudioPlayerMusicWave from '@/components/audio-player/AudioPlayerMusicWave.vue';

export default {
  name: 'AudioPlayer',

  components: {
    'mj-audio-player-music-wave': AudioPlayerMusicWave,
  },

  model: {
    prop: 'forcePlayFromParent',
  },

  props: {
    src: {
      type: String,
      required: true,
    },

    forcePlayFromParent: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isPlaying: false,
    };
  },

  watch: {
    forcePlayFromParent: {
      handler(value) {
        if (value) {
          this.play();
        } else {
          this.pause();
        }
      },
    },
  },

  methods: {
    play() {
      window.eventBus.$emit('pauseAllOtherAudioPlayers', this.$refs.audioPlayer);
      this.$refs.audioPlayer.play();
      this.$emit('input', true);
    },

    pause() {
      this.$refs.audioPlayer.pause();
      this.$emit('input', false);
    },
  },

  created() {
    window.eventBus.$on('pauseAllOtherAudioPlayers', audioPlayer => {
      if (this.$refs.audioPlayer && audioPlayer !== this.$refs.audioPlayer) {
        this.$refs.audioPlayer.pause();
        this.$emit('input', false);
      }
    });
  },
};

</script>
